import React, { memo, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Text } from '@Sage/hoi-poi-ui';

import { getLiteral } from 'utils/getLiteral';

import StartFromScratchIllustration from '../../assets/startFromScratch.svg';

/**
 * Unified blank starter card with visual and HTML editor actions on hover.
 */
const CreateFromScratchCard = memo(({ onSelectVisual, onSelectHtml }) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleSelectVisual = useCallback(() => {
        onSelectVisual?.();
    }, [onSelectVisual]);

    const handleSelectHtml = useCallback(() => {
        onSelectHtml?.();
    }, [onSelectHtml]);

    return (
        <div
            className="marketing-templates-create-from-scratch"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div className="marketing-templates-create-from-scratch__thumb">
                <StartFromScratchIllustration
                    className="marketing-templates-create-from-scratch__illustration"
                    aria-hidden="true"
                />
                {isHovered && (
                    <div className="marketing-templates-create-from-scratch__overlay">
                        <Button onClick={handleSelectVisual}>
                            {getLiteral('label_marketing_campaigns_design_email_builder')}
                        </Button>
                        <Button onClick={handleSelectHtml}>
                            {getLiteral('label_marketing_campaigns_design_html_editor')}
                        </Button>
                    </div>
                )}
            </div>
            <div className="marketing-templates-create-from-scratch__meta">
                <Text
                    type="subtitle"
                    medium
                    className="marketing-templates-create-from-scratch__title"
                >
                    {getLiteral('label_marketing_campaigns_templates_start_from_scratch')}
                </Text>
            </div>
        </div>
    );
});

CreateFromScratchCard.displayName = 'CreateFromScratchCard';

CreateFromScratchCard.propTypes = {
    onSelectHtml: PropTypes.func,
    onSelectVisual: PropTypes.func,
};

export default CreateFromScratchCard;
